<template>
  <div class="container contact_us-block">
    <shape-head-image-component
      v-if="getIsMobile"
      desktop_src="/images/page_data/contact_us.jpg"
      mobile_src="/images/page_data/contact_us-thumb.jpg"
      mobile_src_lazy="/images/page_data/contact_us.jpg"
    />
    <div class="row contact_us-block__row">
      <div class="col-sm-6 col-12">
<!--        <a :href="`mailto:${get_mailto}`" class="contact_us-block__mailto">{{get_mailto}}</a>-->
        <default-title
          smaller
          class="contact_us-block__title"
          :title="$t('title.contact_us_subscribe_title')"
        />
        <social-links
          light
          no_padding
          class="mt-20 contact_us-block__social-links"
          :size="30"
        />
        <div class="mt-120 mt-xs-60 contact_us-block__job-link">
          <default-button
            :href="get_jobs_url"
            is_light
            bordered>
            {{$t('text.see_available_jobs')}}
          </default-button>
        </div>
      </div>
      <div class="col-sm-6 col-12 contact_us-block__form">
        <div class="contact_us-block__form-title-block">
          <default-title
            smaller
            :title="get_title"
            title_tag="h1"
          />
          <html-block
            class="mt-20"
            :content="get_content"
          />
        </div>

        <get-in-touch-form class="mt-40"/>
      </div>
    </div>
  </div>
</template>

<script>

import GetInTouchForm from "../parts/GetInTouchForm.vue";
import DefaultTitle from "../small_parts/DefaultTitle.vue";
import HtmlBlock from "../small_parts/HtmlBlock.vue";
import {JOBS_URL, MAILTO} from "../../helpers/constants";
import SocialLinks from "../parts/footer/SocialLinks.vue";
import DefaultButton from "../slots/DefaultButton.vue";
import ShapeHeadImageComponent from "../parts/ShapeHeadImageComponent.vue";
import {mapGetters} from "vuex";

export default {
  name: "GetInTouchBlock",
  components: {
    ShapeHeadImageComponent,
    DefaultButton,
    SocialLinks,
    HtmlBlock,
    DefaultTitle,
    GetInTouchForm
  },
  props: {
    /**props**/
    content: {
      type: String,
      default: '',
      admin_type: 'editor',
    },
    title: {
      type: String,
      default: '',
      admin_type: 'input',
    },
    email: {
      type: String,
      default: '',
      admin_type: 'input',
    },
    /**props**/
  },
  computed: {
    ...mapGetters([
      'getIsMobile'
    ]),
    get_title() {
      return this.title ? this.title : this.$t('title.contact_us_title')
    },
    get_content() {
      return this.content ? this.content : this.$t('text.contact_us_text')
    },
    get_mailto() {
      if (this.email) return this.email
      return MAILTO
    },
    get_jobs_url() {
      return JOBS_URL
    }
  }
}
</script>
